<!-- <div class="container-xxl mb-100">
  <div class="card-grey mt-2 mt-md-5 text-center">
    <h2>{{'ERROR-404.TITULO' | translate }}</h2>
    <p class="text-center">{{'ERROR-404.DESCRICAO' | translate }}</p>
    <button class="card-primary_button btn btn-lg btn-primary" [routerLink]="['/']">
      {{'ERROR-404.BOTAO' | translate }}
    </button>
  </div>
</div> -->

<div class="container-primary">
  <div class="card-primary">
    <img class="card-primary_logo" alt="Agência Nacional de Águas" src="assets/img/menu/logo-SNISB.svg">
    <div class="row">
      <h3 class="card-primary_title">{{'ERROR-404.TITULO' | translate }}</h3>
    </div>
    <div class="row">
      <p class="card-primary_description">{{'ERROR-404.DESCRICAO' | translate }}</p>
    </div>
    <button class="card-primary_button btn btn-lg btn-primary" [routerLink]="['/']">  {{'ERROR-404.BOTAO' | translate }}
    </button>
  </div>
</div>
